import { DateTime, Settings } from "luxon";
Settings.defaultLocale = "de-CH";
let app = window.app || {};

/**	Füllt das Fenster mit den Einsatz-Details aus den in app.data.missions gespeicherten Daten
 *
 */
app.getAnmeldeForm = async function (callback) {
  let mission = {};

  function formatToPhoneNumber(str) {
    // Alles was nicht Zahlen (\d) oder «+» sind mit "" ersetzen
    // TODO: LibPhoneNumber einbauen
    return str.replace(/[^\d\+]/g, "");
  }
  // Kategorie 1
  mission[bez["i1-bezeichnung"]] = $("#anmeldeform #i1-bezeichnung").val();
  mission[bez["i1-bezeichnung-id"]] = $(
    "#anmeldeform #i1-bezeichnung-id"
  ).val();
  mission[bez["i1-station"]] = $("#anmeldeform #i1-station").val();
  mission[bez["i1-station-id"]] = $("#anmeldeform #i1-station-id").val();
  mission[bez["i1-kontaktperson"]] = $("#anmeldeform #i1-kontaktperson").val();
  mission[bez["i1-telefon"]] = formatToPhoneNumber(
    $("#anmeldeform #i1-telefon").val()
  );
  mission[bez["i1-id"]] = app.customer.id;

  // Kategorie 2
  mission[bez["i2-bezeichnung"]] = $("#anmeldeform #i2-bezeichnung").val();
  mission[bez["i2-bezeichnung-id"]] = $(
    "#anmeldeform #i2-bezeichnung-id"
  ).val();
  mission[bez["i2-haus"]] = $("#anmeldeform #i2-haus").val();
  mission[bez["i2-strasse"]] = $("#anmeldeform #i2-strasse").val();
  mission[bez["i2-plz"]] = $("#anmeldeform #i2-plz").val();
  mission[bez["i2-ort"]] = $("#anmeldeform #i2-ort").val();
  mission[bez["i2-land"]] = $("#anmeldeform #i2-land").val();
  mission[bez["i2-station"]] = $("#anmeldeform #i2-station").val();
  mission[bez["i2-station-id"]] = $("#anmeldeform #i2-station-id").val();
  mission[bez["i2-stock"]] = $("#anmeldeform #i2-stock").val();
  mission[bez["i2-zimmer"]] = $("#anmeldeform #i2-zimmer").val();
  mission[bez["i2-kontaktperson"]] = $("#anmeldeform #i2-kontaktperson").val();
  mission[bez["i2-telefon"]] = formatToPhoneNumber(
    $("#anmeldeform #i2-telefon").val()
  );
  mission[bez["i2-latitude"]] = $("#anmeldeform #i2-lat").val();
  mission[bez["i2-longitude"]] = $("#anmeldeform #i2-lng").val();

  // Kategorie 4
  mission[bez["i4-bezeichnung"]] = $("#anmeldeform #i4-bezeichnung").val();
  mission[bez["i4-bezeichnung-id"]] = $(
    "#anmeldeform #i4-bezeichnung-id"
  ).val();
  mission[bez["i4-haus"]] = $("#anmeldeform #i4-haus").val();
  mission[bez["i4-strasse"]] = $("#anmeldeform #i4-strasse").val();
  mission[bez["i4-plz"]] = $("#anmeldeform #i4-plz").val();
  mission[bez["i4-ort"]] = $("#anmeldeform #i4-ort").val();
  mission[bez["i4-land"]] = $("#anmeldeform #i4-land").val();
  mission[bez["i4-station"]] = $("#anmeldeform #i4-station").val();
  mission[bez["i4-station-id"]] = $("#anmeldeform #i4-station-id").val();
  mission[bez["i4-stock"]] = $("#anmeldeform #i4-stock").val();
  mission[bez["i4-zimmer"]] = $("#anmeldeform #i4-zimmer").val();
  mission[bez["i4-kontaktperson"]] = $("#anmeldeform #i4-kontaktperson").val();
  mission[bez["i4-telefon"]] = formatToPhoneNumber(
    $("#anmeldeform #i4-telefon").val()
  );
  mission[bez["i4-latitude"]] = $("#anmeldeform #i4-lat").val();
  mission[bez["i4-longitude"]] = $("#anmeldeform #i4-lng").val();

  // Kategorie 3
  mission[bez["i3-transportgrund"]] = $(
    "#anmeldeform #i3-transportgrund option:selected"
  ).data("id");

  // Kategorie 5 (und 7)
  let patient_name = $("#anmeldeform #i5-name").val();
  let patient_vorname = $("#anmeldeform #i5-vorname").val();
  let patient_geburtstag = $("#anmeldeform #i5-geburtsdatum").val();
  let patient_diagnose = $("#anmeldeform #i7-bemerkungen").val();

  // Hack: Rückfahrtszeit an Diagnose anhängen
  if ($("#i8-rucktransport-toggle").prop("checked")) {
    patient_diagnose +=
      "\n\n!Rücktransport! Zeit ungefähr: " + $("#i8-rucktransport").val();
  }

  let keys_in_use_public = JSON.parse(
    app.data.settings.keys_in_use_public.value
  );

  for (let i = 0; i < keys_in_use_public.length; i++) {
    let keyIndex = keys_in_use_public[i];
    let patient;
    try {
      patient = await app.encryptPatientenDaten(
        patient_name,
        patient_vorname,
        patient_geburtstag,
        keyIndex
      );
    } catch (error) {
      app.saveToLog(
        `Fehler Verschlüsseln Patientendaten im Anmeldeformular`,
        {
          error,
          keyIndex
        },
        ERROR
      );
      alert(
        "Es ist ein Fehler bei der Verschlüsselung der Patientendaten aufgetreten. Bitte versuchen Sie es erneut, ansonsten melden Sie sich bitte direkt bei der Rettung St. Gallen unter 0800 22 66 11."
      );
      return;
    }
    let diagnose;
    try {
      diagnose = await app.encryptDiagnose(patient_diagnose, keyIndex);
    } catch (error) {
      app.saveToLog(
        `Fehler Verschlüsseln Diagnose im Anmeldeformular`,
        {
          error,
          keyIndex
        },
        ERROR
      );
      alert(
        "Es ist ein Fehler bei der Verschlüsselung der Diagnose aufgetreten. Bitte versuchen Sie es erneut, ansonsten melden Sie sich bitte direkt bei der Rettung St. Gallen unter 0800 22 66 11."
      );
      return;
    }

    mission[bez["i5-patient-verschl-" + (i + 1)]] = patient;
    mission[bez["i5-diagnose-verschl-" + (i + 1)]] = diagnose;
    mission[bez["i5-schluessel-" + (i + 1)]] = keyIndex;
  }

  mission[bez["i5-initiale"]] = patient_name.substr(0, 1);
  //	Rest Kategorie 5
  mission[bez["i5-fallnummer"]] = $("#anmeldeform #i5-fallnummer").val();
  // Geschlecht Switcher
  mission[bez["i5-geschlecht"]] = $(
    "#anmeldeform [name='i5-geschlecht']:checked"
  ).val();

  // Kategorie 6
  mission[bez["i6-datum"]] = $("#anmeldeform #i6-datum").val();
  mission[bez["i6-zeit"]] = $("#anmeldeform #i6-zeit").val();
  mission[bez["i6-datetime"]] = DateTime.fromISO(
    mission[bez["i6-datum"]] + "T" + mission[bez["i6-zeit"]]
  );
  let dateLabel = $(
    "#anmeldeform input[type='radio'][name='i6-fixpunkt']:checked"
  )
    .parent()
    .text();
  mission[bez["i6-datum-text"]] =
    dateLabel +
    ": " +
    mission[bez["i6-datetime"]].toLocaleString({
      ...DateTime.DATETIME_MED,
      timezone: undefined
    }) +
    " Uhr";

  mission[bez["i6-sofort"]] = $("#anmeldeform #i6-sofort").prop("checked");
  mission[bez["i6-flexibel"]] = $("#anmeldeform #i6-flexibel").prop("checked");
  mission[bez["i6-fixpunkt"]] = $(
    "#anmeldeform input[type='radio'][name='i6-fixpunkt']:checked"
  ).val();

  // Kategorie 7
  // => Wurde bei Patient integriert

  // Kategorie 8
  mission[bez["i8-isoliert"]] = $("#anmeldeform #i8-isoliert").prop("checked");
  mission[bez["i8-infusion"]] = $("#anmeldeform #i8-infusion").prop("checked");
  mission[bez["i8-perfusor"]] = Number($("#anmeldeform #i8-perfusor").val());
  mission[bez["i8-monitor"]] = $("#anmeldeform #i8-monitor").prop("checked");
  mission[bez["i8-sauerstoff"]] = $("#anmeldeform #i8-sauerstoff").prop(
    "checked"
  );
  mission[bez["i8-isolette"]] = $("#anmeldeform #i8-isolette").prop("checked");
  mission[bez["i8-beatmet"]] = $("#anmeldeform #i8-beatmet").prop("checked");
  mission[bez["i8-gepaeck"]] = $("#anmeldeform #i8-gepaeck").prop("checked");

  // 8-mobil Switcher
  mission[bez["i8-fahrzeug"]] = $(
    "#anmeldeform input[type=radio][name=i8-fahrzeug]:checked"
  ).val();
  mission[bez["i8-position"]] =
    $("#anmeldeform [name=i8-mobil]:checked").val() ||
    $("#anmeldeform input[type=radio][name=i8-rollstuhl]:checked").val();

  switch (mission[bez["i8-position"]]) {
    case "sitting":
      mission[bez["i8-liegend"]] = false;
      mission[bez["i8-sitzend"]] = true;
      break;

    case "lying":
      mission[bez["i8-liegend"]] = true;
      mission[bez["i8-sitzend"]] = false;
      break;

    default:
      mission[bez["i8-liegend"]] = false;
      mission[bez["i8-sitzend"]] = false;
      break;
  }
  // Falls Transportposition nicht gesetzt, default verwenden
  mission[bez["i8-position"]] = mission[bez["i8-position"]] || "lying";

  mission[bez["i8-rollstuhl"]] =
    $("#anmeldeform input[type=radio][name=i8-rollstuhl]:checked").val() || "";

  // 8-perfusor Text ausgeben
  if (mission[bez["i8-perfusor"]] == 0) {
    mission[bez["i8-perfusor-text"]] = "";
  } else if (mission[bez["i8-perfusor"]] == 1) {
    mission[bez["i8-perfusor-text"]] = "1&nbsp;Perfusor, ";
  } else {
    mission[bez["i8-perfusor-text"]] =
      mission[bez["i8-perfusor"]] + "&nbsp;Perfusoren, ";
  }

  // Selbstzahler abrfagen
  mission[bez["i8-selbstzahler"]] =
    $("#anmeldeform input[type=radio][name=i8-selbstzahler]:checked").val() ===
    "ja";

  // Kategorie 9
  mission[bez["i9-begleitung"]] = $(
    "#anmeldeform input[type=radio][name=i9-begleitung]:checked"
  ).val();
  mission[bez["i9-polizei"]] = $("#anmeldeform #i9-polizei").prop("checked");
  mission[bez["i9-familie"]] = $("#anmeldeform #i9-familie").prop("checked");
  mission[bez["i9-hebamme"]] = $("#anmeldeform #i9-hebamme").prop("checked");
  mission[bez["i9-kispiteam"]] = $("#anmeldeform #i9-kispiteam").prop(
    "checked"
  );
  mission[bez["i9-begleitung-text"]] = String(
    $("#anmeldeform #i9-begleitung-text").val()
  );

  // Erstellen des Falles
  mission[bez["i1-datum"]] = DateTime.local().toISODate();
  mission[bez["i1-zeit"]] = DateTime.local().toFormat("HH:mm");

  if (callback) {
    callback(mission);
  }
};

/**	Zusammenfassung anzeigen
 *
 */
app.zeigeZusammenfassung = function (mission) {
  /**	Ausnahmen generieren
   *
   */
  const missionLog = Object.entries(mission)
    .filter(([key, item]) => !key.startsWith("patients"))
    .map((item) => item[1]);
  app.saveToLog(
    "zeigeZusammenfassung shown",
    {
      customerId: app.customer.id,
      customerLabel: app.customer.username,
      mission: missionLog
    },
    INFO
  );
  // Zeit zum Ausfüllen berechnen
  let ausfuellzeit = new Date().getTime() - app.data.startTime;
  mission[bez["i0-ausfuellzeit"]] = Math.round(ausfuellzeit / 1000);

  // Patient Abkürzung
  if (mission[bez["i5-geschlecht"]] === "f") {
    mission[bez["i5-kurzfassung"]] =
      "Frau " + mission[bez["i5-initiale"]] + ".";
  } else if (mission[bez["i5-geschlecht"]] === "m") {
    mission[bez["i5-kurzfassung"]] =
      "Herr " + mission[bez["i5-initiale"]] + ".";
  } else {
    // Geschlecht Divers
    mission[bez["i5-kurzfassung"]] =
      "Pat. " + mission[bez["i5-initiale"]] + ".";
  }

  // Untersuchungsart
  mission[bez["i3-transportgrund-text"]] = String(
    $("#i3-transportgrund option:selected").text()
  );

  if (Number($("#i3-transportgrund option:selected").data("priority")) === 1) {
    $(
      "#zusammenfassungReveal [data-content='i3-transportgrund-text']"
    ).addClass("alertText");
  } else {
    $(
      "#zusammenfassungReveal [data-content='i3-transportgrund-text']"
    ).removeClass("alertText");
  }

  // Telefonnummern formatieren
  mission[bez["i1-telefon"]] = app.phoneFormat(mission[bez["i1-telefon"]]);
  mission[bez["i2-telefon"]] = app.phoneFormat(mission[bez["i2-telefon"]]);
  mission[bez["i4-telefon"]] = app.phoneFormat(mission[bez["i4-telefon"]]);

  // Transportmittel
  mission[bez["i8-fahrzeug-text"]] = $(
    `label[for=i8-${$("[name=i8-fahrzeug]:checked").val()}]`
  )
    .text()
    .trim();
  mission[bez["i8-rollstuhl-text"]] = $(
    `label[for=i8-${$("[name=i8-rollstuhl]:checked").val()}]`
  )
    .text()
    .trim();

  // Transportposition
  if (mission[bez["i8-position"]] == "lying" && $("#i8-lying").is(":checked")) {
    mission[bez["i8-lying"]] = "liegend";
    mission[bez["i8-sitting"]] = "";
    mission[bez["i8-walking"]] = "";
  } else if (mission[bez["i8-position"]] == "sitting") {
    mission[bez["i8-lying"]] = "";
    mission[bez["i8-sitting"]] = "sitzend";
    mission[bez["i8-walking"]] = "";
  } else if (mission[bez["i8-position"]] == "walking") {
    mission[bez["i8-lying"]] = "";
    mission[bez["i8-sitting"]] = "";
    mission[bez["i8-walking"]] = "gehend";
  } else {
    mission[bez["i8-lying"]] = "";
    mission[bez["i8-sitting"]] = "";
    mission[bez["i8-walking"]] = "";
  }

  // Selbstzahler
  if ($("#i8-selbstzahler-ja").is(":checked")) {
    mission[bez["i8-selbstzahler-text"]] = "Selbstzahler";
  } else if ($("#i8-selbstzahler-nein").is(":checked")) {
    mission[bez["i8-selbstzahler-text"]] = "kein Selbstzahler";
  }

  /* Ende Ausnahmen generieren */

  // Restliche Dinge automatisch füllen
  $.each(mission, function (index, text) {
    // Titel herausfinden
    let titel;
    if (
      $("#" + bezInv[index])
        .parent()
        .is("label")
    ) {
      titel = $("#" + bezInv[index])
        .parent()
        .text();
    } else if (
      $("#" + bezInv[index])
        .parent()
        .parent()
        .is("label")
    ) {
      titel = $("#" + bezInv[index])
        .parent()
        .parent()
        .text();
    } else if (
      $("#" + bezInv[index])
        .parent()
        .is(".input-group-label")
    ) {
      titel = $("#" + bezInv[index])
        .parent()
        .text();
    } else {
      titel = $("#" + bezInv[index])
        .parent()
        .parent()
        .text();
    }

    titel = titel.trim();

    // Falls Element vorhanden Titel ausfüllen
    $("#zusammenfassungReveal [data-label='" + bezInv[index] + "']").html(
      titel
    );

    // index = destination_phone
    // titel = Tel. direkt
    // text = 079 000 00 00

    // Falls Element vorhanden Text ausfüllen (text==false/true heisst Checkbox)
    if (text !== true && text !== false && text !== "") {
      $("#zusammenfassungReveal [data-content='" + bezInv[index] + "']").html(
        text
      );
      // Falls append/prepend vorhanden diesen vor/nach Text hängen
      $(
        "#zusammenfassungReveal [data-content='" +
          bezInv[index] +
          "'][data-prepend]"
      ).prepend(function () {
        return $(this).data("prepend");
      });
      $(
        "#zusammenfassungReveal [data-content='" +
          bezInv[index] +
          "'][data-append]"
      ).append(function () {
        return $(this).data("append");
      });
      // Falls append/prepend vorhanden diesen vor/nach Text hängen
    } else if (text === true) {
      $("#zusammenfassungReveal [data-content='" + bezInv[index] + "']").html(
        titel
      );
      // Falls append/prepend vorhanden diesen vor/nach Text hängen
      $(
        "#zusammenfassungReveal [data-content='" +
          bezInv[index] +
          "'][data-prepend]"
      ).prepend(function () {
        return $(this).data("prepend");
      });
      $(
        "#zusammenfassungReveal [data-content='" +
          bezInv[index] +
          "'][data-append]"
      ).append(function () {
        return $(this).data("append");
      });
      // Falls append/prepend vorhanden diesen vor/nach Text hängen
    } else if (text === false || text === "") {
      // Felder leeren
      $("#zusammenfassungReveal [data-content='" + bezInv[index] + "']").html(
        ""
      );
    }
    // Ende Falls vorhanden Text ausfüllen
  });
  // Letztes Komma bei Aufzählungen entfernen.
  $(".komma-liste").find(".komma:last").hide();

  app.karte.waypoints = {};
  // TODO: Koordinaten aus Stammdaten werden so gar nie beachtet!
  app.karte.geocodeAddress(
    mission[bez["i2-strasse"]],
    mission[bez["i2-plz"]],
    mission[bez["i2-ort"]],
    function (point) {
      app.karte.waypoints.startPoint = point;
      app.karte.getAndDisplayRoute(
        app.karte.waypoints.startPoint,
        app.karte.waypoints.endPoint
      );
    }
  );
  app.karte.geocodeAddress(
    mission[bez["i4-strasse"]],
    mission[bez["i4-plz"]],
    mission[bez["i4-ort"]],
    function (point) {
      app.karte.waypoints.endPoint = point;
      app.karte.getAndDisplayRoute(
        app.karte.waypoints.startPoint,
        app.karte.waypoints.endPoint
      );
    }
  );

  // Zusammenfassung öffnen
  $("#zusammenfassungReveal").foundation("open");
  $("#zusammenfassungReveal .button.submit").toggleClass("disabled", true);
};
// Ende Zusammenfassung anzeigen

/**	Lade Session-Daten
 *
 */
app.ladeSessiondaten = async function (count) {
  if (count > 5) {
    app.reLogin();
  }
  
  const response = await fetch(app.backend + "/me", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    }
  });

  const data = await response.json();

  if (response.status >= 400) {
    if (response.status == 403) {
      console.warn("not logged in, attempt #" + count);
    } else {
      console.error(response.status, { data });
    }
    setTimeout(() => {
      // retry
      app.ladeSessiondaten(count + 1 || 1);
    }, 200);
  }

  if (!app.customer) {
    app.customer = {};
  }
  app.customer.data = data.customer || {};
  app.customer.id = data.uuid;

  if (typeof data.customer?.configOrdersAllowed == "string") {
    data.customer.configOrdersAllowed = JSON.parse(
      data.customer.configOrdersAllowed
    );
  }
  let configOrdersAllowed = data.customer?.configOrdersAllowed ?? {};

  // check for admin first, because admin inherits customer role too
  if (data.isAdmin || !data.isCustomer) {
    app.customer.type = 11;
  } else if (data.isCustomer) {
    app.customer.type = 10;
  }
  app.customer.username = data.username || app.customer.id;

  $(".benutzername").text(app.customer.username);

  // Prüfen, welche Fahrzeuge erlaubt sind
  if (configOrdersAllowed.resourceRth) {
    $("label[for='i8-rth']").removeClass("hide");
  }
  if (configOrdersAllowed.resourceRtw) {
    $("label[for='i8-rtw']").removeClass("hide");
  }
  if (
    Object.keys(app.customer.data).length &&
    !configOrdersAllowed.resourceKtw
  ) {
    $("label[for='i8-ktw']").addClass("hide");
  }
  if (configOrdersAllowed.resourceNonmedical) {
    $("label[for='i8-lying_taxi']").removeClass("hide");
  }
  if (configOrdersAllowed.resourceWheelchairTaxi) {
    $("label[for='i8-wheelchair_taxi']").removeClass("hide");
  }
  if (configOrdersAllowed.resourceTaxi) {
    $("label[for='i8-taxi']").removeClass("hide");
  }
  if (
    !configOrdersAllowed.resourceNonmedical &&
    !configOrdersAllowed.resourceWheelchairTaxi &&
    !configOrdersAllowed.resourceTaxi
  ) {
    // Falls eh nur KTW in Frage kommt, diesen vorauswählen
    $("#i8-ktw").trigger("click");
  }

  // onload-bugfix
  $("[name=i8-fahrzeug]:checked").trigger("appEvent.checked");

  $("#i5-fallnummer").prop("required", data.configFidRequired);
  // Bei required-Felder ein Stern ans Label anfügen
  $("[required]:not(:radio)")
    .parent()
    .parent()
    .find("label, .input-group-label")
    .each(function () {
      if (!$(this).text().endsWith("*")) {
        $(this).append("*");
      }
    });

  // Selbstzahler standardmässig auf nein stellen
  // if (!$("[name=i8-selbstzahler]").is(":checked")) {
  //   $("#i8-selbstzahler-nein").prop("checked", true);
  // }

  async function fillFormData(count2) {
    if (count2 > 5) {
      app.reLogin();
    }

    if (app.customer.data.ward?.uuid) {
      const response = await fetch(app.backend + "/wards/" + app.customer.data.ward.uuid, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      });

      const ward = await response.json();

      if (response.status >= 400) {
        setTimeout(() => {
          // retry
          fillFormData(count2 + 1 || 1);
        }, 500);
        throw new Error("Formulardaten nicht erhalten: " + response.status, ward);
      }

      $("#anmeldeform .session-complete").each(function () {
        if (String($(this).val()).length === 0) {
          switch ($(this).prop("id")) {
            case "i1-bezeichnung":
              $(this).val(ward.institution.label);
              break;
            case "i1-bezeichnung-id":
              $(this).val(ward.institution.uuid);
              break;
            case "i1-station":
              $(this).val(ward.label).trigger("change");
              break;
            case "i1-station-id":
              $(this).val(ward.uuid);
              break;
            case "i1-telefon":
              $(this).val(app.customer.data.phone);
              break;
            case "i2-bezeichnung":
              $(this).val(ward.institution.label);
              break;
            case "i2-bezeichnung-id":
              $(this).val(ward.institution.uuid);
              break;
            case "i2-strasse":
              $(this).val(ward.address.street);
              break;
            case "i2-plz":
              $(this).val(ward.address.zip);
              break;
            case "i2-ort":
              $(this).val(ward.address.location);
              break;
            case "i2-land":
              $(this).val(ward.address.country);
              break;
            case "i2-lat":
              $(this).val(ward.address.lat);
              break;
            case "i2-lng":
              $(this).val(ward.address.long);
              break;
            case "i2-station":
              if (app.customer.data.configPickupSelf) {
                $(this).val(ward.label);
              }
              break;
            case "i2-station-id":
              if (app.customer.data.configPickupSelf) {
                $(this).val(ward.uuid);
              }
              break;
            case "i2-telefon":
              if (app.customer.data.configPickupSelf) {
                $(this).val(ward.phone);
              }
              break;
            case "i2-haus":
              if (app.customer.data.configPickupSelf) {
                $(this).val(ward.address.house);
              }
              break;
            case "i2-stock":
              if (app.customer.data.configPickupSelf) {
                $(this).val(ward.address.floor);
              }
              break;
          }
        }
      });

      setTimeout(function () {
        app.aktiviereTypeahead(undefined, 1);
        app.aktiviereTypeahead(undefined, 2);
        app.aktiviereTypeahead(undefined, 4);
      }, 100);
    } else if (app.customer.data.institution?.uuid) {
      const response = await fetch(app.backend + "/institutions/" + app.customer.data.institution.uuid, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",  
          Accept: "application/json"
        }
      });
      const institution = await response.json();
      if (response.status >= 400) {
        setTimeout(() => {
          // retry
          fillFormData(count2 + 1 || 1);
        }, 500);
        throw new Error("Formulardaten nicht erhalten: " + response.status, institution);
      }

      $("#anmeldeform .session-complete").each(function () {
        if (String($(this).val()).length === 0) {
          switch ($(this).prop("id")) {
            case "i1-bezeichnung":
              $(this).val(institution.label);
              break;
            case "i1-bezeichnung-id":
              $(this).val(institution.uuid);
              break;
            case "i1-telefon":
              $(this).val(app.customer.data.phone);
              break;
            case "i2-bezeichnung":
              $(this).val(institution.label);
              break;
            case "i2-bezeichnung-id":
              $(this).val(institution.uuid);
              break;
            case "i2-strasse":
              $(this).val(institution.address.street);
              break;
            case "i2-plz":
              $(this).val(institution.address.zip);
              break;
            case "i2-ort":
              $(this).val(institution.address.location);
              break;
            case "i2-land":
              $(this).val(institution.address.country);
              break;
            case "i2-lat":
              $(this).val(institution.address.lat);
              break;
            case "i2-lng":
              $(this).val(institution.address.long);
              break;
          }
        }
      });

      setTimeout(function () {
        app.aktiviereTypeahead(undefined, 1);
        app.aktiviereTypeahead(undefined, 2);
        app.aktiviereTypeahead(undefined, 4);
      }, 100);
    }
  }

  fillFormData();
};
// Ende Lade Session-Daten

/** 	Lade Stationsübersicht
 *
 */
app.ladeStationsubersicht = async function () {
  const response = await fetch(app.backend + "/wardpatients", { 
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    }
  });

  const data = await response.json();

  if (response.status >= 400) {
    if (app.customer.type != 10) {
      $("table#stationsUbersicht tbody").replaceWith(
        $("<tr>").append(
          $("<td>", { colspan: 8 }).append(
            $("<div>", { class: "callout warning" }).text(
              "Keine Transportübersicht verfügbar, da als Operator angemeldet."
            )
          )
        )
      );
      return;
    }
    // Prüfen, ob vielleicht einfach nur ausgeloggt wurde
    if (response.status == 403) {
      app.reLogin();
    } else {
      throw new Error("Fehler in ladeStationsubersicht: " + textStatus);
    }
  }

  let newTBody = $("<tbody>");

  data.forEach((mission) => {
    // Anrede
    let salutation = "";
    if (mission.gender == "f") {
      salutation = "Frau";
    } else if (mission.gender == "m") {
      salutation = "Herr";
    } else {
      salutation = mission.initial ? "Pat." : "";
    }

    let lockIcon = mission.timeIsFlexible ? "fa-unlock" : "fa-lock";
    let calculatedIcon = "fa-sliders";

    let $pickupEl = $("<td>");
    let $destinationEl = $("<td>");
    if (mission.timeFixpoint == "pickup") {
      let pickupDateTime = DateTime.fromISO(mission.timePickup);
      let destinationDateTime = pickupDateTime.plus({
        minutes:
          2 * app.data.settings.reload_time.value +
          mission.transportDuration
      });

      $pickupEl
        .attr("data-sort-value", pickupDateTime.toMillis())
        .addClass("icon " + lockIcon)
        .append(
          $("<br>"),
          pickupDateTime.toFormat("dd.MM.yyyy '<br />' HH:mm 'Uhr'")
        );
      $destinationEl
        .attr("data-sort-value", destinationDateTime.toMillis())
        .addClass("icon calculated " + calculatedIcon)
        .append(
          $("<br>"),
          destinationDateTime.toFormat(
            "dd.MM.yyyy '<br />&asymp;' HH:mm 'Uhr'"
          )
        );
    } else if (mission.timeFixpoint == "destination") {
      // Fixpoint destination
      let destinationDateTime = DateTime.fromISO(mission.timeDestination);
      let pickupDateTime = destinationDateTime.minus({
        minutes:
          2 * app.data.settings.reload_time.value +
          mission.transportDuration
      });

      $pickupEl
        .attr("data-sort-value", pickupDateTime.toMillis())
        .addClass("icon calculated")
        .append(
          $("<i>", { class: "icon fa " + calculatedIcon }),
          $("<br>"),
          pickupDateTime.toFormat("dd.MM.yyyy '<br />&asymp;' HH:mm 'Uhr'")
        );
      $destinationEl
        .attr("data-sort-value", destinationDateTime.toMillis())
        .addClass("icon")
        .append(
          $("<i>", { class: "icon fa " + lockIcon }),
          $("<br>"),
          destinationDateTime.toFormat("dd.MM.yyyy '<br />' HH:mm 'Uhr'")
        );
    } else {
      // Fall hat keine Abhol/Zielortzeit (typisch für Status 13, noch offene Rückfahrten)
      $pickupEl.attr("data-sort-value", 0);
      $destinationEl.attr("data-sort-value", 0);
    }

    $("<tr/>")
      .data("id", mission.uuid)
      .append($pickupEl)
      .append($destinationEl)
      .append(
        $("<td>").append(
          $("<br>"),
          `${mission.pickup.institutionLabel || ""}, ${
            mission.pickup.wardLabel || ""
          }`.replace("St. ", "St.&#8239;")
        )
      )
      .append(
        $("<td>").append(
          $("<br>"),
          `${mission.destination.institutionLabel || ""}, ${
            mission.destination.wardLabel || ""
          }`.replace("St. ", "St.&#8239;")
        )
      )
      .append(
        $("<td>")
          .attr("data-sort-value", mission.initial || "")
          .append(
            $("<br>"),
            `${salutation} ${mission.initial || ""}.`,
            $("<br>"),
            $("<span>", { class: "fa-stack" }).append(
              $("<i>", { class: "fa fa-circle fa-stack-2x" }).addClass(
                function () {
                  switch (mission.resourcetype) {
                    case "ktw":
                      return "color-primary";
                    case "rth":
                    case "rtw":
                      return "color-alert";
                    case "lying_taxi":
                    case "wheelchair_taxi":
                    case "taxi":
                      return "color-warning";
                    default:
                      return "color-primary";
                  }
                }
              ),
              $("<i>", { class: "fa fa-inverse fa-stack-1x" }).addClass(
                function () {
                  switch (mission.resourcetype) {
                    case "ktw":
                      return "fa-bus";
                    case "rtw":
                      return "fa-ambulance";
                    case "rth":
                      return "fa-helicopter";
                    case "lying_taxi":
                      return "fa-bed";
                    case "wheelchair_taxi":
                      return "fa-wheelchair-alt";
                    case "taxi":
                      return "fa-taxi";
                    default:
                      return "fa-car";
                  }
                }
              )
            )
          )
      )
      .append(
        $("<td>")
          .attr("data-sort-value", mission.fid || "")
          .append($("<br>"), mission.fid ? "F:&nbsp;" + mission.fid : "")
      )
      .append(
        $("<td>")
          .attr("data-sort-value", mission.mission.number)
          .append(
            $("<i>", { class: "fa " }).addClass(function () {
              if (mission.seenByUser) {
                return "fa-check";
              } else {
                return "fa-pulse fa-spinner";
              }
            }),
            !mission.seenByUser ? " in Bearbeitung" : " angenommen",
            $("<br>"),
            mission.mission.number
          )
          .append(function () {
            if (mission.mission.resource) {
              return `<br />${mission.mission.resource.label}`;
            }
          })
      )
      .append(
        $("<td>")
          .attr("data-sort-value", mission.customerName || "")
          .append($("<br>"), mission.customerName || "")
      )
      .prependTo(newTBody);
  });

  // bestehende Tabelle ersetzen
  let newTable = $("table#stationsUbersicht");
  newTable.find("tbody").replaceWith(newTBody);

  // StupidTable erneut zu sortieren
  $(newTable)
    .find("thead th")
    .each(function () {
      if ($(this).hasClass("sorting-asc")) {
        $(this).stupidsort("asc");
      } else if ($(this).hasClass("sorting-desc")) {
        $(this).stupidsort("desc");
      }
    });
  $("table#stationsUbersicht").replaceWith(newTable);
};
// Ende Lade Stationsübersicht

/**	Leere Formular
 *
 */
app.leereFormular = function (scroll) {
  $("#anmeldeform").foundation("resetForm");
  setTimeout(function () {
    $("#anmeldeform select").prop("selectedIndex", 0).trigger("change");

    $("#anmeldeform .initialState").trigger("click");

    $("#anmeldeform #i5-geburtsdatum, #i6-datum").val("");

    $("#anmeldeform .id-feld").val("");

    // Fahrzeug-Auswahl zurücksetzen
    $("#anmeldeform #i8-mobil")
      .prop("disabled", true)
      .animate({ opacity: 0 }, { display: "none" })
      .find("input:radio")
      .removeProp("required checked");
    $("#anmeldeform #i8-rollstuhl")
      .prop("disabled", true)
      .animate({ opacity: 0 }, { display: "none" })
      .find("input:radio")
      .removeProp("required checked");
    $("#anmeldeform, #missionDetail")
      .find("#i8-helptext")
      .animate({ opacity: 0 }, { display: "none", duration: 0 });

    app.anmeldeformDirty = false;

    setTimeout(function () {
      app.ladeSessiondaten();
    }, 10);
  }, 10);
  if (scroll) {
    let contentDiv = document.querySelector("article .content");
    if (contentDiv.scrollTop < 50) {
      contentDiv.querySelector("main .button:first-child").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
  }
};
// Ende Lade Session-Daten

/**	Speichere Einsatz in Datenbank
 *
 */
app.speichereNeueMission = async function (mission, callback) {
  let m = mission;

  app.saveToLog("MissionFilloutTime", m.log_fillout_time, INFO, true);

  let timePickup = null,
    timeDestination = null;
  if (m[bez["i6-fixpunkt"]] == "pickup") {
    timePickup = m[bez["i6-datetime"]].toISO();
  } else {
    timeDestination = m[bez["i6-datetime"]].toISO();
  }

  let customerIri =
    app.customer.type == 10
      ? new URL(app.backend).pathname + `/customers/${app.customer.id}`
      : undefined;
  let pickupInstitution = m[bez["i2-bezeichnung-id"]]
    ? new URL(app.backend).pathname +
      "/institutions/" +
      m[bez["i2-bezeichnung-id"]]
    : undefined;
  let pickupWard = m[bez["i2-station-id"]]
    ? new URL(app.backend).pathname + "/wards/" + m[bez["i2-station-id"]]
    : undefined;
  let destinationInstitution = m[bez["i4-bezeichnung-id"]]
    ? new URL(app.backend).pathname +
      "/institutions/" +
      m[bez["i4-bezeichnung-id"]]
    : undefined;
  let destinationWard = m[bez["i4-station-id"]]
    ? new URL(app.backend).pathname + "/wards/" + m[bez["i4-station-id"]]
    : undefined;

  mission = {
    customer: customerIri,
    customerInstitutionLabel: m[bez["i1-bezeichnung"]],
    customerInstitutionWardLabel: m[bez["i1-station"]],
    customerName: m[bez["i1-kontaktperson"]],
    customerPhone: m[bez["i1-telefon"]],
    status: 10,
    patients: [
      {
        customer: customerIri,
        customerInstitutionLabel: m[bez["i1-bezeichnung"]],
        customerInstitutionWardLabel: m[bez["i1-station"]],
        customerName: m[bez["i1-kontaktperson"]],
        customerPhone: m[bez["i1-telefon"]],
        initial: m[bez["i5-initiale"]],
        gender: m[bez["i5-geschlecht"]],
        fid: m[bez["i5-fallnummer"]],
        isIsolated: m[bez["i8-isoliert"]],
        resourcetype: m[bez["i8-fahrzeug"]],
        transportType:
          new URL(app.backend).pathname +
          "/transport_types/" +
          m[bez["i3-transportgrund"]],
        transportPosition: m[bez["i8-position"]],
        pickup: {
          institutionLabel: m[bez["i2-bezeichnung"]],
          institution: pickupInstitution,
          wardLabel: m[bez["i2-station"]],
          ward: pickupWard,
          phone: m[bez["i2-telefon"]],
          address: {
            street: m[bez["i2-strasse"]],
            zip: m[bez["i2-plz"]],
            location: m[bez["i2-ort"]],
            country: m[bez["i2-land"]],
            house: m[bez["i2-haus"]],
            floor: m[bez["i2-stock"]],
            room: m[bez["i2-zimmer"]],
            lat: m[bez["i2-latitude"]],
            long: m[bez["i2-longitude"]]
          }
        },
        destination: {
          institutionLabel: m[bez["i4-bezeichnung"]],
          institution: destinationInstitution,
          wardLabel: m[bez["i4-station"]],
          ward: destinationWard,
          phone: m[bez["i4-telefon"]],
          address: {
            street: m[bez["i4-strasse"]],
            zip: m[bez["i4-plz"]],
            location: m[bez["i4-ort"]],
            country: m[bez["i4-land"]],
            house: m[bez["i4-haus"]],
            floor: m[bez["i4-stock"]],
            room: m[bez["i4-zimmer"]],
            lat: m[bez["i4-latitude"]],
            long: m[bez["i4-longitude"]]
          }
        },
        timePickup,
        timeDestination,
        timeFixpoint: m[bez["i6-fixpunkt"]],
        timeIsImmediate: m[bez["i6-sofort"]],
        timeIsFlexible: m[bez["i6-flexibel"]],
        transportDuration: m[bez["i10-transportzeit"]],
        transportDistance: m[bez["i10-transportdistanz"]],
        data1: m[bez["i5-patient-verschl-1"]],
        data2: m[bez["i5-patient-verschl-2"]],
        data3: m[bez["i5-patient-verschl-3"]],
        remark1: m[bez["i5-diagnose-verschl-1"]],
        remark2: m[bez["i5-diagnose-verschl-2"]],
        remark3: m[bez["i5-diagnose-verschl-3"]],
        key1: m[bez["i5-schluessel-1"]],
        key2: m[bez["i5-schluessel-2"]],
        key3: m[bez["i5-schluessel-3"]],
        hasInfusion: m[bez["i8-infusion"]],
        hasOxygen: m[bez["i8-sauerstoff"]],
        hasMonitoring: m[bez["i8-monitor"]],
        hasIsolette: m[bez["i8-isolette"]],
        hasBigLuggage: m[bez["i8-gepaeck"]],
        hasVentilation: m[bez["i8-beatmet"]],
        perfusor: m[bez["i8-perfusor"]],
        escort: m[bez["i9-begleitung"]],
        escortOther: m[bez["i9-begleitung-text"]],
        isSelfpay: m[bez["i8-selbstzahler"]]
      }
    ]
  };

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(mission)
  };

  try {
    const response = await fetch(app.backend + "/missions", options);
    const data = await response.json();

    if (response.status == 403) {
      app.reLogin();
      console.warn("not logged in", data);
    } else if (response.status >= 400) {
      console.error("response.status", response.status);
      throw data;
    }
    callback(data);
  } catch (error) {
    console.error("app.speichereNeueMission fehlgeschlagen: ", error);
    callback(error);
  }
};
// Ende Speichere Einsatz in Datenbank

/** Generiere die Karte
 *
 */
app.karte = {};

app.karte.zeigeRoutingKarte = function () {
  let currentYear = DateTime.local().get("year");
  L.Icon.Default.imagePath = "../js/vendor/leaflet-images";

  app.karte.map = new L.Map("routingKarte", {
    center: [47.2494, 9.34328],
    zoom: 8
  });

  new L.TileLayer(
    "https://wmts{s}.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg",
    {
      subdomains: "0123456789",
      minZoom: 2,
      maxNativeZoom: 19,
      maxZoom: 22,
      className: "maptiles-desaturate",
      attribution: "Map data &copy; " + currentYear + " swisstopo"
    }
  ).addTo(app.karte.map);
};
app.karte.getAndDisplayRoute = async function (startPoint, endPoint) {
  if (
    !startPoint?.lat ||
    !startPoint?.lng ||
    !endPoint?.lat ||
    !endPoint?.lng
  ) {
    return;
  }
  if (!app.karte?.map) {
    // Falls die Karte noch nicht existiert
    setTimeout(function () {
      app.karte.getAndDisplayRoute(startPoint, endPoint);
    }, 500);
    return;
  }

  app.karte.map.fitBounds([
    L.latLng(startPoint.lat, startPoint.lng),
    L.latLng(endPoint.lat, endPoint.lng)
  ]);

  let query = new URLSearchParams({
    point0: `${startPoint.lat},${startPoint.lng}`,
    point1: `${endPoint.lat},${endPoint.lng}`
  }).toString();
  query = query.replace("point0", "point[0]").replace("point1", "point[1]");

  const resp = await fetch(`${app.backend}/gh/route?${query}`, {
    method: "GET"
  });
  const data = await resp.json();

  let latLngPolyline = data.paths[0].points.coordinates.map((x) => {
    // make [lon, lat] to [lat, lon];
    return [x[1], x[0]];
  });
  window.latLngPolyline = latLngPolyline;

  // remove old route
  app.karte.polyline1?.remove();
  app.karte.polyline2?.remove();

  // add it multiple times for nicer visualization
  app.karte.polyline1 = L.polyline(latLngPolyline, {
    color: "#00b4f7",
    opacity: 0.8,
    weight: 12,
    interactive: false
  }).addTo(app.karte.map);
  app.karte.polyline2 = L.polyline(latLngPolyline, {
    color: "#00fdf6",
    opacity: 0.8,
    weight: 2,
    interactive: false
  }).addTo(app.karte.map);

  app.karte.waypoints.time = parseInt(data.paths[0].time / 1000 / 60, 10); //now in minutes
  app.karte.waypoints.distance = parseInt(data.paths[0].distance / 1000, 10); // now in kilometers

  app.mission[bez["i2-latitude"]] = startPoint.lat;
  app.mission[bez["i2-longitude"]] = startPoint.lng;
  app.mission[bez["i4-latitude"]] = endPoint.lat;
  app.mission[bez["i4-longitude"]] = endPoint.lng;
  app.mission[bez["i10-transportzeit"]] = app.karte.waypoints.time;
  app.mission[bez["i10-transportdistanz"]] = app.karte.waypoints.distance;
  $("#zusammenfassungReveal .button.submit").toggleClass("disabled", false);
};
app.karte.geocodeAddress = async function (strasse, plz, ort, callback) {
  let isFallback = false;
  if (strasse == "Fallback") {
    strasse = "";
    isFallback = true;
  }
  const query = new URLSearchParams({
    q: [strasse, plz, ort].join(" "),
    limit: "1"
  }).toString();

  const resp = await fetch(`${app.backend}/gh/geocode?${query}`, {
    method: "GET"
  });

  const data = await resp.json();

  let point = { lat: 46.505, lng: 6.626 }; // Default Lausanne am Genfersee
  if (data.hits?.length) {
    point = data.hits[0].point;
    callback(point);
  } else {
    // Fallback nur mit Ortschaft
    if (!isFallback) {
      app.karte.geocodeAddress("Fallback", "", ort, callback);
    } else {
      callback(point);
    }
  }
};
// Ende Generiere die Karte …
